import {
  kbAiProposalSchema,
  kbAssistantChatResponseSchema,
  kbOptimizationDashboardSchema,
  kbOptimizationRunQueuedSchema,
  type AiChatMessage,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const kbOptimizationQueryKey = ['kb', 'optimization'] as const;

export function useKbOptimization() {
  return useQuery({
    queryKey: kbOptimizationQueryKey,
    queryFn: () => apiFetch('/kb/optimization', kbOptimizationDashboardSchema),
    refetchInterval: (query) =>
      query.state.data?.lastRun && !query.state.data.lastRun.finishedAt ? 3000 : false,
  });
}

export function useRunKbOptimization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch('/kb/optimization/run', kbOptimizationRunQueuedSchema, { method: 'POST' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: kbOptimizationQueryKey });
    },
  });
}

export function useKbAssistantChat() {
  return useMutation({
    mutationFn: (body: { messages: AiChatMessage[]; articleSlug?: string }) =>
      apiFetch('/kb/assistant/chat', kbAssistantChatResponseSchema, {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}

export function useApplyKbProposal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch(`/kb/proposals/${id}/apply`, kbAiProposalSchema, { method: 'POST' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['kb'] });
    },
  });
}

export function useRejectKbProposal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch(`/kb/proposals/${id}/reject`, kbAiProposalSchema, { method: 'POST' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['kb'] });
    },
  });
}
